import { apiRequest } from "./apiClient";
import { DEFAULT_LIST_PAGE_SIZE } from "../constants/listPagination";
import type {
  GeneratedContractDetailJson,
  PaginatedGeneratedContractsResponse
} from "../types/generatedContract";

export type FetchMyGeneratedContractsParams = {
  readonly limit?: number;
  readonly offset?: number;
  /** @deprecated Server ignores; listing is org-wide for users with contracts access. */
  readonly mine?: boolean;
  /** @deprecated Server ignores; listing is org-wide for users with contracts access. */
  readonly assigned_to_me?: boolean;
  readonly contract_type?: string;
  readonly contract_origination?: string;
  /** Substring match on `display_name` (server strips `%`, `_`, `\`). */
  readonly q?: string;
  /** Match `stored_files.business_unit` (case-insensitive trim). */
  readonly business_unit?: string;
  /** Repeatable on the wire — single status or omit for all. */
  readonly status?: readonly string[];
};

export async function fetchMyGeneratedContracts(
  params: FetchMyGeneratedContractsParams = {}
): Promise<{ items: GeneratedContractDetailJson[]; total: number }> {
  const limit = params.limit ?? DEFAULT_LIST_PAGE_SIZE;
  const offset = params.offset ?? 0;
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  const ct = params.contract_type?.trim();
  if (ct) q.set("contract_type", ct);
  const co = params.contract_origination?.trim();
  if (co) q.set("contract_origination", co);
  const bu = params.business_unit?.trim();
  if (bu) q.set("business_unit", bu);
  const search = params.q?.trim();
  if (search) q.set("q", search);
  if (params.status?.length) {
    for (const s of params.status) {
      const t = s.trim();
      if (t) q.append("status", t);
    }
  }
  const response = await apiRequest(`/generated-contracts?${q.toString()}`);
  const json = (await response.json()) as PaginatedGeneratedContractsResponse;
  const items = Array.isArray(json.data) ? json.data : [];
  const total = json.meta?.total ?? items.length;
  return { items, total };
}
